<template>
  <div class="box">
    <!--  -->
    <div
      class="input-phone-box backgeoundfff clearfix"
      style="background:#6495ED;width:100%;"
    >
      <div
        class="key center fl"
        style="width:100%;font-size:.3rem;font-weight: 600;color:#fff; "
      >
        人员实名
      </div>
    </div>

    <!--  -->
    <div class="input-phone-box backgeoundfff clearfix">
      <div class="key fl">手机号：</div>
      <div class="vlo fl">
        <!-- <input class="input" type="number" value="" placeholder="请输入手机号" v-model="shoujihao">
        -->
        <input
          class="input"
          type="text"
          placeholder="请输入手机号"
          v-model="username"
        />
      </div>
      <div class="cx-btn fr" @click="formValidate()">验证</div>
    </div>
    <div class="main-box">
      <div class="input-phone-box backgeoundfff clearfix">
        <div class="key fl">姓 名：</div>
        <div class="vlo fl">
          <!-- {{name}} -->
          {{ this.xingming }}
        </div>
      </div>
      <div class="input-phone-box backgeoundfff clearfix">
        <div class="key fl">岗位/工种：</div>
        <div class="vlo fr text-right" @click="showPopup">
          {{ this.gongzhong }}
          <img class="img" src="@/assets/images/icon/fanhui.png" alt />
        </div>
      </div>
      <!--  -->
      <div
        class="input-phone-box backgeoundfff marginbottom0 clearfix"
        style="display:flex;"
      >
        <div class="key fl">上传图片：</div>
        <div
          class="pdf"
          @click="jump()"
          style="line-height:.8rem;color:#6495ED;width:76%;text-align:right"
        >
          查看上传人脸规则
        </div>
      </div>
      <!--  -->

      <div class="imgUpload backgeoundfff">
        <div class="dynamic-imgs">
          <div class="table-list">
            <div v-for="(img, index) in dynamicPics" :key="index" class="shows">
              <img class="img-add" :src="img" @click="clickImg(img, index)" />
              <div class="btn" @click="delImg(img, index)">
                <img src="@/assets/images/icon/gb.png" alt />
              </div>
            </div>
            <div v-show="isAddImg()">
              <van-uploader :after-read="onRead" accept="image/*" multiple>
                <img class="img-add" src="@/assets/images/zhengmian@3x.png" />
              </van-uploader>
            </div>
            <!-- 第二个 -->
            <div
              v-for="(img, index) in dynamicPics2"
              :key="index"
              class="shows"
            >
              <img class="img-add" :src="img" @click="clickImg(img, index)" />
              <div class="btn" @click="delImg2(img, index)">
                <img src="@/assets/images/icon/gb.png" alt />
              </div>
            </div>
            <div v-show="isAddImg2()">
              <van-uploader :after-read="onRead2" accept="image/*" multiple>
                <img class="img-add" src="@/assets/images/fanmian@3x.png" />
              </van-uploader>
            </div>
          </div>
        </div>

        <div class="dynamic-imgs tiaozheng">
          <div class="table-list">
            <div
              v-for="(img, index) in dynamicPics3"
              :key="index"
              class="shows"
            >
              <img class="img-add" :src="img" @click="clickImg(img, index)" />
              <div class="btn" @click="delImg3(img, index)">
                <img src="@/assets/images/icon/gb.png" alt />
              </div>
            </div>
            <div v-show="isAddImg3()">
              <van-uploader :after-read="onRead3" accept="image/*" multiple>
                <img class="img-add" src="@/assets/images/renlian@3x.png" />
              </van-uploader>
            </div>
          </div>
        </div>
        <dialog-view-img
          :isShow="isSelectImg"
          :imgInfo="viewImg"
          @showTag="previewImg()"
        ></dialog-view-img>
      </div>
      <div class="input-phone-box backgeoundfff clearfix" v-show="xianshi">
        <div class="key fl">审核状态：</div>
        <div class="vlo fl">
          <!-- {{name}} -->
          {{ this.salary }}
        </div>
      </div>
      <div class="tijiaoanniu" @click="submission">提交</div>
      <van-popup
        v-model="show"
        round
        position="bottom"
        :style="{ height: '40%' }"
        style="padding:.20rpx:"
      >
        <div class="list-box" v-for="item in typeofwork" :key="item.index">
          <div class="typeofworklist" @click="pickupinformation(item)">
            {{ item.dictLabel }}
          </div>
        </div>
      </van-popup>
      <div v-cloak>
        <div class="confirmLayercovering" id="confirmLayercovering">
          <div class="confirmLayer" id="confirmLayer">
            <p class="confirmTit" id="confirmTit">确定提交么?></p>
            <div class="confirmbtns">
              <a class="confirmClose" id="confirmClose">取消</a>
              <a class="confirmSure" id="confirmSure">确定</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogViewImg from "@/assets/viewImg/dialogViewImg";
import common from "@/assets/js/common";
import Slick from "vue-slick";
import echarts from "echarts";
import API from "@/service/common.service.js";

export default {
  components: { dialogViewImg },
  name: "Confirm",
  data() {
    //
    return {
      dynamicPics: [], //存放添加图片
      dynamicPics2: [], //存放添加图片
      dynamicPics3: [], //存放添加图片
      isSelectImg: false, //开启弹窗标志
      viewImg: {}, //放置预览图片信息

      show: false,
      typeofwork: [{ name: "店小二" }, { name: "店小三" }],
      shoujihao: "",
      username: "",
      gongzhong: "请选择工种",
      xingming: "未知",
      salary: "",
      gzlblist: [],
      jobs: "",
      id: "",
      // 人脸照片
      facePhoto: "",
      // 身份证正面照片
      idcardPhoto: "",
      // 身份证反面照片
      idcardReversePhoto: "",
      xianshi: false,
      //
      show: false,
      number: 1,
      facePhotoimgurl: "",
      idcardPhotoimgurl: "",
      idcardReversePhotoimgurl: ""
    };
  },
  created() {},
  mounted() {
    // this.getDictDataListByType();
  },
  computed: {},
  methods: {
    jump: function() {
      this.$router.push({
        path: "/pdf"
      });
    },
    //确认弹窗
    ConfirmLayer: function(txt, callback) {
      var _this = this;
      var confirmLayercovering = document.getElementById(
          "confirmLayercovering"
        ),
        confirmTit = document.getElementById("confirmTit"),
        confirmClose = document.getElementById("confirmClose"),
        confirmSure = document.getElementById("confirmSure"),
        confirmCall = callback,
        tittxt = txt;
      if (!confirmLayercovering) {
        return;
      }
      var init = function() {
          if (txt) {
            confirmTit.innerHTML = txt;
          }
          show();
          confirmClose.addEventListener("click", function() {
            hide();
            confirmCall && confirmCall(false);
          });
          confirmSure.addEventListener("click", function() {
            hide();
            confirmCall && confirmCall(true);
          });
        },
        hide = function() {
          confirmLayercovering.style.display = "none";
        },
        show = function() {
          confirmLayercovering.style.display = "block";
        },
        Confirm = function(txt, callback) {
          if (tittxt != txt && txt) {
            confirmTit.innerHTML = txt;
            tittxt = txt;
          }
          confirmCall = callback;
          show();
        };
      init(); //初始化
      _this.ConfirmLayer = Confirm; //下次不用再初始化
    },
    openConfirm() {
      let _this = this;
      _this.ConfirmLayer("确认要跳转吗？", function(flag) {
        if (flag) {
          console.log("确认");
        } else {
          console.log("取消");
        }
      });
    },

    //

    submission() {
      var _this = this;
      if (this.username == "") {
        this.$toast("请输入手机号");
      } else if (!/^1[3456789]\d{9}$/.test(this.username)) {
        this.$toast("手机号码有误，请重填");
      } else if (this.id == "") {
        this.$toast("请输入手机号，并点击【验证】");
      } else if (this.jobs == "") {
        this.$toast("请选择工种");
      } else if (this.dynamicPics == "") {
        this.$toast("请上传身份证正面照片");
      } else if (this.dynamicPics2 == "") {
        this.$toast("请上传身份证反面照片");
      } else if (this.dynamicPics3 == "") {
        this.$toast("请上传人脸照片");
      } else {
        let _this = this;
        if (this.salary == "审核成功") {
          _this.ConfirmLayer(
            "您已有审核通过的照片，提交审核，会删除已有设备的照片，请确认是否提交审核？",
            function(flag) {
              if (flag) {
                console.log("确认");
                // 公众号-提交审核
                _this.wechatCommitPhoto();
              } else {
                console.log("取消");
              }
            }
          );
        } else {
          _this.ConfirmLayer("确认要提交吗？", function(flag) {
            if (flag) {
              console.log("确认");
              // 公众号-提交审核
              _this.wechatCommitPhoto();
            } else {
              console.log("取消");
            }
          });
        }
      }
    },
    //
    pickupinformation(e) {
      console.log(e);
      this.gongzhong = e.dictLabel;
      this.jobs = e.dictValue;
      this.show = false;
    },
    //
    formValidate: function(event) {
      if (this.username == "") {
        // 弹出返回文字
        this.$toast("请输入手机号");
      } else if (!/^1[3456789]\d{9}$/.test(this.username)) {
        this.$toast("手机号码有误，请重填");
      } else {
        // 赋值手机号
        let data = this.username;
        // 获取字典列表
        this.checkPhoneIsExists(data);
      }
    },

    //
    showPopup() {
      this.show = true;
      // 获取字典列表接口
      this.getDictDataListByType();
    },
    //

    isAddImg() {
      console.log(this.dynamicPics);
      //如果已经9张了，isAddImg为false，隐藏加号
      if (this.dynamicPics.length >= 1) {
        return false;
      } else {
        return true;
      }
    },

    isAddImg2() {
      console.log(this.dynamicPics);
      //如果已经9张了，isAddImg为false，隐藏加号
      if (this.dynamicPics2.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isAddImg3() {
      console.log(this.dynamicPics);
      //如果已经9张了，isAddImg为false，隐藏加号
      if (this.dynamicPics3.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    // 上传图片插件（身份证正面）
    onRead(file) {
      console.log(file);
      //添加图片
      this.dynamicPics.push(file.content);
      this.imgPreview(file.file);
    },
    // 上传图片插件（身份证反面）
    onRead2(file) {
      console.log(file);
      //添加图片
      this.dynamicPics2.push(file.content);
      this.imgPreview1(file.file);
    },
    // 上传图片插件（人脸）
    onRead3(file) {
      console.log(file);
      //添加图片
      this.dynamicPics3.push(file.content);
      this.imgPreview2(file.file);
    },
    //点击图片事件
    clickImg(url, index) {
      console.log(url, index);
      //获得图片的url和index，传给弹窗
      this.viewImg = {
        url: url,
        index: index
      };
      //打开弹窗
      this.isSelectImg = true;
    },
    //预览图片返回
    previewImg(value) {
      //关闭弹窗
      this.isSelectImg = false;
    },
    delImg(value) {
      console.log(value);
      //点击删除时，返回图片在数组中的index
      if (value !== null) {
        console.log("删除图片", value.index);
        this.dynamicPics.splice(value.index, 1);
      }
    },
    delImg2(value) {
      console.log(value);
      //点击删除时，返回图片在数组中的index
      if (value !== null) {
        console.log("删除图片", value.index);
        this.dynamicPics2.splice(value.index, 1);
      }
    },
    delImg3(value) {
      console.log(value);
      //点击删除时，返回图片在数组中的index
      if (value !== null) {
        console.log("删除图片", value.index);
        this.dynamicPics3.splice(value.index, 1);
      }
    },
    // 公众号-根据手机号检测是否存在
    checkPhoneIsExists(data) {
      console.log(data);
      let form_data = new FormData();
      form_data.append("phone", data);
      API.checkPhoneIsExists(form_data).then(res => {
        console.log(res);
        if (res.data.code == 0) {
          this.typeofwork = res.data.pd;
          this.id = res.data.pd.id;
          this.jobs = res.data.pd.jobs;
          this.gongzhong = res.data.pd.jobsName;
          this.xingming = res.data.pd.name;

          if (res.data.pd.status == "none" || res.data.pd.status == "dsh") {
            this.salary = "待审核";
            this.xianshi = false;
          }
          if (res.data.pd.status == "success") {
            this.salary = "审核成功";
            this.xianshi = true;
          }
          if (res.data.pd.status == "fail") {
            this.salary = "审核失败";
            this.xianshi = true;
            this.$toast("审核失败请重新 [提交] 审核");
          }
          // 人脸
          if (res.data.pd.facePhotoUrl == "") {
          } else {
            if (this.dynamicPics3.length < 1) {
              // 人脸
              this.facePhotoimgurl = res.data.pd.facePhotoUrl;
              var a =
                "http://hubery-test.oss-cn-beijing.aliyuncs.com" +
                this.facePhotoimgurl;
              this.dynamicPics3.push(a);
              console.log(a);
            }
          }
          // 正面
          if (res.data.pd.idcardPhotoUrl == "") {
          } else {
            if (this.dynamicPics.length < 1) {
              // 正面
              this.idcardPhotoimgurl = res.data.pd.idcardPhotoUrl;
              var b =
                "http://hubery-test.oss-cn-beijing.aliyuncs.com" +
                this.idcardPhotoimgurl;
              this.dynamicPics.push(b);
              console.log(b);
            }
          }
          // 反面
          if (res.data.pd.idcardReversePhotoUrl == "") {
          } else {
            if (this.dynamicPics2.length < 1) {
              // 反面
              this.idcardReversePhotoimgurl = res.data.pd.idcardReversePhotoUrl;
              var c =
                "http://hubery-test.oss-cn-beijing.aliyuncs.com" +
                this.idcardReversePhotoimgurl;
              this.dynamicPics2.push(c);
              console.log(c);
            }
          }

          //

          // 反面
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
          this.dynamicPics2 = [];
          this.dynamicPics = [];
          this.dynamicPics3 = [];
          (this.gongzhong = "请选择工种"),
            (this.xingming = "未知"),
            (this.xianshi = false);
          // 刷新页面
          // var int=self.setInterval(function(){  // 这个方法是说在延迟两秒后执行大括号里的方法
          //   location.reload();   // 这个方法是刷新当前页面
          // },2000) //这里2000代表两秒
          // this.$router.go(0);
          // 人脸照片 初始化
          // this.facePhoto = '',
          //  this.delImg(value)
          // 身份证正面照片 初始化
          // this.idcardPhoto = '',
          //  this.delImg2(value)

          // 身份证反面照片 初始化
          // this.idcardReversePhoto = '',
          this.delImg3(value);
        }
      });
    },
    // 获取字典列表
    getDictDataListByType() {
      let form_data = new FormData();
      form_data.append("type", "personJobs");
      API.getDictDataListByType(form_data).then(res => {
        console.log(res);
        if (res.data.code == 0) {
          this.typeofwork = res.data.dicList;
        } else {
          // 弹出返回文字
          // this.$toast(res.data.msg);
        }
      });
    },
    // 公众号-提交审核
    wechatCommitPhoto() {
      var id = this.id;
      console.log(this.jobs);
      let form_data = new FormData();
      // ID
      form_data.append("id", id);
      // jobs
      form_data.append("jobs", this.jobs);
      // 人脸照片
      form_data.append("facePhoto", this.facePhoto);
      // 身份证正面照片
      form_data.append("idcardPhoto", this.idcardPhoto);
      // 身份证反面照片
      form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.wechatCommitPhoto(form_data).then(res => {
        console.log(res);
        if (res.data.code == 0) {
          this.typeofwork = res.data.dicList;
          this.$router.push({
            path: "/success"
          });
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
    // 处理图片
    imgPreview(file) {
      let self = this;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          // console.log(this.result);
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于2m,是就直接上传，反之压缩图片
          if (this.result.length <= 1024 * 1024 * 2) {
            self.idcardPhoto = file;
          } else {
            img.onload = function() {
              let data = self.compress(img);
              console.log(self.dataURLtoFile(data, file.name, file.type));
              self.idcardPhoto = self.dataURLtoFile(data, file.name, file.type);
            };
          }
        };
      }
    },
    imgPreview1(file) {
      let self = this;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          // console.log(this.result);
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于2m,是就直接上传，反之压缩图片
          if (this.result.length <= 1024 * 1024 * 2) {
            self.idcardReversePhoto = file;
          } else {
            img.onload = function() {
              let data = self.compress(img);
              console.log(self.dataURLtoFile(data, file.name, file.type));
              self.idcardReversePhoto = self.dataURLtoFile(
                data,
                file.name,
                file.type
              );
            };
          }
        };
      }
    },
    imgPreview2(file) {
      let self = this;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          // console.log(this.result);
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于2m,是就直接上传，反之压缩图片
          if (this.result.length <= 1024 * 1024 * 2) {
            self.facePhoto = file;
          } else {
            img.onload = function() {
              let data = self.compress(img);
              console.log(self.dataURLtoFile(data, file.name, file.type));
              self.facePhoto = self.dataURLtoFile(data, file.name, file.type);
            };
          }
        };
      }
    },
    // 压缩图片
    compress(img) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }

      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },

    //将base64转换为文件
    dataURLtoFile(dataurl, name, type) {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, {
        type: type
      });
    }
  }
};
</script>

<style lang="scss">
@import url("//unpkg.com/element-ui@2.13.0/lib/theme-chalk/index.css");
.box {
  .baise {
    background: #ffffff;
  }
  font-size: 0.32rem;
  overflow: hidden scroll;
  width: 100%;
  height: 100%;
  // border: 1px solid red;
  // padding: 0.3rem 0.6rem;
  background: #f7f7f7;
  .input-phone-box {
    width: 100%;
    height: 0.8rem;
    // border: 1px solid red;
    line-height: 0.8rem;
    padding: 0 0.2rem;
    margin-bottom: 0.2rem;
    display: flex;
    position: relative;
    .key {
      width: 27%;
      height: 0.8rem;
      // border: 1px solid red;
    }
    .vlo {
      width: 3rem;
      height: 0.8rem;
      // border: 1px solid red;
      .input {
        width: 100%;
        height: 100%;
        // border: 1px solid #0f0;
        outline: none;
        border: none;
      }
      .img {
        display: block;
        float: right;
        width: 0.5rem;
        height: 0.3rem;
        margin-top: 0.2rem;
      }
    }
    .cx-btn {
      width: 1rem;
      height: 0.6rem;
      text-align: center;
      line-height: 0.6rem;
      border: 1px solid #fff;
      background: #fff;
      border-radius: 0.1rem;
      color: #6495ed;
      margin-top: 0.05rem;
      position: absolute;
      right: 0.2rem;
      top: 0;
    }
    .text-right {
      text-align: left;
      width: 73%;
    }
  }
  .marginbottom0 {
    margin-bottom: 0;
  }
}

.imgUpload {
  // height: 100vh;
  width: 100%;
  // background: #f8f8f8;
  font-size: 14px;
  overflow-x: hidden;
  margin-bottom: 0.2rem;
  .dynamic-imgs {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    /* min-height: 152px; */
    /* width: 50%; */
    background-color: #ffffff;
    padding: 12px;
    margin-bottom: 6.5px;
    /* padding-left: .8rem; */
    // float: left;
    .img-title {
      margin-bottom: 12px;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0.16px;
    }
    .table-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      display: flex;
      justify-content: space-around;

      .img-add {
        width: 96px;
        height: 96px;
        margin-right: 12px;
        margin-bottom: 12px;
      }
      .shows {
        width: 96px;
        height: 96px;
        margin-right: 12px;
        margin-bottom: 12px;
        position: relative;

        .btn {
          position: absolute;
          top: 0;
          right: 0;
          margin: auto;
          width: 0.3rem;
          height: 0.3rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  // .tiaozheng{
  //   width: 100%;
  //   padding-left: 2.7rem;
  // }
}
.typeofworklist {
  width: 100%;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  font-size: 0.3rem;
}

.van-popup--bottom.van-popup--round {
  padding: 0.3rem 0.2rem;
}
.tijiaoanniu {
  width: 7rem;
  height: 0.8rem;
  margin: 0 auto;
  background: cornflowerblue;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  font-size: 0.3rem;
  color: #fff;
  margin-top: 1rem;
}
.backgeoundfff {
  background: #fff;
}
.center {
  text-align: center;
}
//

button {
  border: none;
  padding: 0.05rem 0.1rem;
  border-radius: 5px;
  background: lightcoral;
  color: #ffffff;
}

/* 确认弹框 start */
.confirmLayercovering {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1005;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  font-size: 0;
}

.confirmLayer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4rem;
  height: 3rem;
  background: #fff;
  border-radius: 10px;
  padding: 0.1rem;
  box-sizing: border-box;
}

.confirmTit {
  width: 100%;
  height: 65%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #333;
  font-size: 0.16rem;
  text-align: center;
}

.confirmbtns {
  width: 100%;
  height: 35%;
  display: flex;
}

.confirmbtns a {
  display: inline-block;
  flex: 1;
  height: 0.7rem;
  line-height: 0.7rem;
  border-radius: 4px;
  font-size: 0.16rem;
  text-align: center;
}

.confirmClose {
  background-color: #bbb;
  color: #fff;
  margin-right: 0.1rem;
}

.confirmSure {
  background: #6495ed;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue